<template>
  <div class="member-engagement">
    <h1>Member Engagement</h1>
    <div v-show="inited">
      <b-tabs type="is-boxed is-toggle"
              v-model="selectedTab">

        <b-tab-item label="Member Engagement"
                    value="member-engagement">
          <h2>Member Engagement</h2>
          <br />
          <message-list :message-type="MILO_MESSAGE_TYPE_BOD_MESSAGE">
          </message-list>
        </b-tab-item>

        <b-tab-item label="Member Quarterly"
                    value="member-quarterly">
          <report-list title="Member Quarterly"
                       :report-type="MILO_MESSAGE_TYPE_MEMBER_QUARTERLY">
          </report-list>
        </b-tab-item>

        <b-tab-item label="Annual Report"
                    value="annual-report">
          <report-list title="Annual Report"
                       :report-type="MILO_MESSAGE_TYPE_BOD_ANNUAL_REPORT">
          </report-list>
        </b-tab-item>

      </b-tabs>
    </div>
  </div>
</template>

<script>
import MessageList from '../components/MessageList.vue'
import ReportList from '../components/ReportList.vue'

export default {
    name: 'MemberEngagement',
    components: {
        MessageList,
        ReportList,
    },
    props: {
        messageType: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            inited: false,
            selectedTab: undefined,

            // TODO: these are hard-coded..how to share w/ backend enum?
            // MILO_MESSAGE_TYPE_GM_MESSAGE: 1,
            // MILO_MESSAGE_TYPE_GM_ENDS_REPORT: 2,
            MILO_MESSAGE_TYPE_BOD_MESSAGE: 3,
            MILO_MESSAGE_TYPE_BOD_ANNUAL_REPORT: 4,
            // MILO_MESSAGE_TYPE_BA_MESSAGE: 7,
            MILO_MESSAGE_TYPE_MEMBER_QUARTERLY: 8,
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // is someone logged in?
            if (this.$store.state.user.uuid) {

                // send non-members back to "home" page
                if (!this.$store.state.user.member) {
                    this.$router.push('/')
                }

            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // if url requests a specific tab, show that
            if (this.messageType) {
                this.selectedTab = this.messageType
            }

            // we did it!
            this.inited = true
        },
    },
}
</script>
